<!-- 多品类购买 -->
<template>
    <div class="mainsale">
        <!-- 筛选栏 -->
        <div class="filter-bar">
            <div style="display: flex; align-items: center; margin-bottom: 10px" v-if="sisadmin">
                管理员专属:<el-input v-model="adminpatch" style="width: 220px"></el-input>
                <el-button @click="usepatch">go!</el-button>
            </div>
            <el-form class="demo-ruleForm" inline v-model="ruleForm">
                <!-- 选择平台 -->
                <el-form-item class="form-item">
                    <el-select v-model="ruleForm.platform" placeholder="选择平台">
                        <el-option label="淘宝" value="taobao"></el-option>
                        <el-option label="闲鱼" value="xianyu"></el-option>
                        <el-option label="拼多多" value="pinduoduo"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 选择品类 -->
                <el-form-item class="form-item">
                    <el-select v-model="ruleForm.category" placeholder="选择品类">
                        <el-option label="手机" value="phone"></el-option>
                        <el-option label="电脑" value="computer"></el-option>
                        <el-option label="家电" value="homeappliance"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 选择等级 -->
                <el-form-item class="form-item">
                    <el-select v-model="ruleForm.level" placeholder="选择等级">
                        <el-option label="A" value="A"></el-option>
                        <el-option label="B" value="B"></el-option>
                        <el-option label="C" value="C"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 选择品牌 -->
                <el-form-item class="form-item">
                    <el-select v-model="ruleForm.brand" placeholder="选择品牌">
                        <el-option label="苹果" value="apple"></el-option>
                        <el-option label="华为" value="huawei"></el-option>
                        <el-option label="小米" value="xiaomi"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 查询和重置按钮 -->
                <el-form-item class="form-item">
                    <el-button type="primary" @click="handleSearch">查询</el-button>
                    <el-button @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 数据列表 -->
        <div class="data-table">
            <el-table :data="tableData" border style="border-radius: 12px" :header-row-style="{ color: 'white', backgroundColor: '#6b6b6b' }" stripe>
                <el-table-column prop="sources" label="平台" width="80"></el-table-column>
                <el-table-column prop="category" label="品类" width="100"></el-table-column>
                <el-table-column label="基本信息" width="180">
                    <template #default="scope">
                        <div>
                            <div>{{ scope.row.model }}</div>
                            <div>{{ scope.row.ram }}</div>
                            <div>{{ scope.row.storage }}</div>
                            <div>{{ scope.row.color }}</div>
                            <div>{{ scope.row.purchaseChannel }}</div>
                            <div>{{ scope.row.grade }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="图片" width="300">
                    <template #default="scope">
                        <el-image
                            v-if="scope.row.quotedQuantity === 1"
                            :preview-teleported="true"
                            :infinite="true"
                            :hide-on-click-modal="true"
                            :src="loopfirstimage(scope.row.rawAllImgUrl, scope.row.rawDefectUrl)"
                            :zoom-rate="1.2"
                            :max-scale="7"
                            :min-scale="0.2"
                            :preview-src-list="showallimages(scope.row.rawAllImgUrl, scope.row.rawDefectUrl)"
                            :initial-index="0"
                            fit="cover">
                            <template #error>
                                <div class="image-slot" style="text-align: center; background: #f2f6fc">
                                    <span>平台无图</span>
                                </div>
                            </template>
                        </el-image>
                        <!-- <el-image v-else :preview-teleported="true" :infinite="true" :hide-on-click-modal="true"
                            :src="onemorephonepicsCircle(scope.row.rawAllImgUrl, scope.row.rawDefectUrl)[0]"
                            :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
                            :preview-src-list="onemorephonepicsCircle(scope.row.rawAllImgUrl, scope.row.rawDefectUrl)"
                            :initial-index="0" fit="cover">
                            <template #error>
                                <div class="image-slot" style="text-align: center; background: #f2f6fc">
                                    <span>平台无图</span>
                                </div>
                            </template>
                        </el-image> -->
                    </template>
                </el-table-column>
                <el-table-column label="报告">
                    <template #default="scope">
                        <div style="max-height: 300px; overflow-y: auto">
                            <span style="margin-bottom: 15px; font-weight: 700" v-for="item in parseQualityDesc(scope.row.qualityDesc)" :key="item"
                                >{{ item }}
                                <br />
                            </span>
                            <span style="margin-bottom: 15px" v-for="item in parseQualityDesc(scope.row.allJson)" :key="item"> {{ item }} <br /> </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="upsetPrice" label="起拍价" width="90"></el-table-column>
                <el-table-column label="出价" width="180">
                    <template #default="{ row }">
                        <el-input v-model="row.bidPrice" type="number" placeholder="请输入出价"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="operation" label="操作" width="80">
                    <template #default="{ row }">
                        <el-button type="primary" link @click="handleEdit(row)">出价</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页器 -->
        <div class="pagination">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pageSize"
                :current-page="currentPage"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script setup>
    import { doPurchase, getExtraAccount, getPurchaseResult } from "@/utils/doPurchaseAbout.ts";
    import { extractImageUrls, parseQualityDesc, todaypatch } from "@/utils/utils.js";
    import axios from "axios";
    import { ElMessage, ElMessageBox } from "element-plus";
    import Swal from "sweetalert2";
    import { onMounted, ref } from "vue";

    /* ################################## */
    /*                查询外部账号         */
    /* ################################## */
    const extraAccountId = ref("");
    const fetchExternalAccount = async (sources) => {
        try {
            const data = await getExtraAccount(sources);
            if (data.code !== 200) {
                console.error("获取外部账号数据失败：", data.message);
                return;
            }
            if (data.data[0].accountStatusStr !== "可用") {
                ElMessageBox.error("外部账号不可用，请联系管理员！", {
                    duration: 2000,
                    showClose: true,
                });
                return;
            }

            extraAccountId.value = data.data[0].id;
        } catch (error) {
            console.error("获取外部账号数据失败：", error);
        }
    };
    /* ################################## */
    /*                 出价                 */
    /* ################################## */
    const handleEdit = async (row) => {
        await fetchExternalAccount(row.sources);
        var purchasebody = {
            accountId: extraAccountId.value,
            amount: row.bidPrice,
            stickCode: row.stickCode,
            patch: adminpatch.value,
            infoId: row.infoId,
        };
        await doPurchase(purchasebody);
        var querypara = {
            accountId: extraAccountId.value.toString(),
            stickCode: row.stickCode,
            patch: adminpatch.value,
        };
        setTimeout(async () => {
            var data = await getPurchaseResult(querypara);
            if (data.code !== 200) {
                ElMessage.error("获取出价结果失败：", data.message);
                return;
            }

            var parchaseRes = data.data.result[0];
            if (parchaseRes.status == 0) {
                Swal.fire({
                    title: "出价结果",
                    text: "出价中",
                    icon: "info",
                    confirmButtonText: "确定",
                });
            } else if (parchaseRes.status == 1) {
                ElMessage.success("出价成功！");
            } else if (parchaseRes.status == 2) {
                const orderResult = parchaseRes.orderResult;
                Swal.fire({
                    title: "出价失败",
                    html: `
                <div style="text-align: left;">
                ${parchaseRes.sources}平台提示:${orderResult || "未知错误"}
                </div>
                `,
                    icon: "error",
                    confirmButtonText: "确定",
                });
            }
        }, 2000);
    };
    /* ################################## */
    /*                图片处理                */
    /* ################################## */
    const showallimages = (s, b) => {
        if (s == "" || s == {} || s == undefined) {
            return extractImageUrls(b);
        } else if (s != undefined) {
            return s.split("|").concat(extractImageUrls(b));
        }
    };
    const loopfirstimage = (s, b) => {
        if (s == "" || s == {} || s == undefined) {
            return extractImageUrls(b)[0];
        } else {
            return s.split("|")[0];
        }
    };
    /* ################################## */
    /*                分页相关                */
    /* ################################## */
    const tableData = ref([]); // 表格数据
    const total = ref(0); // 数据总数
    const pageSize = ref(10); // 每页显示条数
    const currentPage = ref(1); // 当前页码
    const handleSizeChange = (size) => {
        pageSize.value = size;
        fetchData();
    };

    const handleCurrentChange = (page) => {
        currentPage.value = page;
        fetchData();
    };

    /* ################################## */
    /*                管理员按钮               */
    /* ################################## */
    const sisadmin = ref(false); // 是否是管理员

    onMounted(() => {
        sisadmin.value = localStorage.authRoleVOList.includes("管理员");
        adminpatch.value = todaypatch();
    });

    const adminpatch = ref("20250406_1"); // 管理员可使用批次
    // 使用批次
    const usepatch = () => {
        ruleForm.value.patch = adminpatch.value;

        fetchData();
    };
    /* ################################## */
    /*            查询商品数据             */
    /* ################################## */
    const ruleForm = ref({
        platform: "",
        category: "",
        level: "",
        brand: "",
        multiplecate: true,
    });
    // 获取数据
    const fetchData = async () => {
        try {
            const response = await axios.get("/api/warePrice/queryWarePrice", {
                params: {
                    ...ruleForm.value,
                    pageNo: currentPage.value,
                    pageSize: pageSize.value,
                },
                headers: {
                    satoken: localStorage.getItem("sa") || "",
                },
            });
            const data = response.data.data;
            tableData.value = data.result || [];
            total.value = data.total || 0;
        } catch (error) {
            console.error("数据获取失败：", error);
        }
    };

    // 查询按钮点击事件
    const handleSearch = () => {
        fetchData();
    };

    // 重置按钮点击事件
    const handleReset = () => {
        adminpatch.value = todaypatch();
        ruleForm.value = {
            platform: "",
            category: "",
            level: "",
            brand: "",
            patch: todaypatch(),
        };
        fetchData();
    };

    /* ################################## */
    /*            页面初始化               */
    /* ################################## */
    fetchData();
</script>

<style scoped lang="scss">
    .mainsale {
        width: 100%;
        overflow: auto;
        color: #ffffff;
        // padding: 20px;
    }

    .filter-bar {
        margin-bottom: 20px;
    }

    .form-item {
        width: 200px;
        margin-right: 10px;
    }

    .data-table {
        margin-bottom: 20px;
    }

    .pagination {
        text-align: right;
    }
</style>
